import { defineMessages } from 'react-intl';

export default defineMessages({
    description: {
        id: 'ml.quoteandbind.farmOrRanch.propertyDescription',
        defaultMessage: 'Property Description'
    },
    itemType: {
        id: 'ml.quoteandbind.farmOrRanch.itemType',
        defaultMessage: 'Item Type'
    },
    limitOfInsurance: {
        id: 'ml.quoteandbind.farmOrRanch.limitOfInsurance',
        defaultMessage: 'Limit Of Insurance'
    },
    action: {
        id: 'ml.quoteandbind.farmOrRanch.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.farmOrRanch.modalTitle',
        defaultMessage: 'Add Farm or Ranch'
    },
    addBtn: {
        id: 'ml.quoteandbind.farmOrRanch.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.farmOrRanch.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.farmOrRanch.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.farmOrRanch.continueBtn',
        defaultMessage: 'Continue'
    },
});
